/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

import { ofType } from 'redux-observable';
import { switchMap, catchError } from 'rxjs/operators';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { user } from '@src/services';
import * as actions from '@src/store/actions';
import * as types from '@src/store/types';

export const getOtherUserProfileCall = (action$, store) =>
  action$.pipe(
    ofType(types.GET_OTHER_USER_PROFILE_CALL),
    switchMap(({ payload, payload: { param } }) =>
      fromPromise(user.getOtherUserProfile(payload)).pipe(
        switchMap((res) => {
          return [
            actions.getOtherUserProfileDone({
              user_id: param.user_id,
              response: res,
            }),
          ];
        }),
        catchError((err) => [
          actions.getOtherUserProfileFail({
            user_id: param.user_id,
            response: err,
          }),
        ])
      )
    )
  );
